import {
  TmDialogElement,
  TmDialogElementStyle,
} from '@thiememeulenhoff/lit-sdk';
import { customElement } from 'lit/decorators.js';
import { styles, tag } from './content.styles';

@customElement(tag)
export class ContentModalComponent extends TmDialogElement {
  override contained = true;

  static override styles = [TmDialogElementStyle, styles];
}

declare global {
  interface HTMLElementTagNameMap {
    'a-content-modal': ContentModalComponent;
  }
}
